import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import actionsIcon from "../../../assets/img/actionImage.svg";
import backIcon from "../../../assets/img/previousArrow.svg";
import accountIcon from "../../../assets/img/accountImg.svg";
import emailIcon from "../../../assets/img/emailIcon.svg";
import locIcon from "../../../assets/img/locationIcon.svg";
import mobileIcon from "../../../assets/img/mobIcon.svg";
import invoicesIcon from "../../../assets/img/invoice-icon.svg";
import totalSalesIcon from "../../../assets/img/totalSalesIcon.svg";
import sarCurrencySymbol from "../../../assets/img/inactive-currency.svg";
import firstInvoicIcon from "../../../assets/img/firstInvoiceIcon.svg";
import loyaltyIcon from "../../../assets/img/loyaltyIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import * as customerActions from "../../../_redux/customers/customersActions";
import axios from "axios";
import moment from "moment";
import { i18n } from "../private/languageSelector";
function ViewCustomerProfile({ show, id, onHide, openEditCustomerDialog, openEditCustomerPointsDialog }) {
  const selectedLanguage = localStorage.getItem("language") || "english";
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({});

  const toggleDropDown = () => {
    setShowDropDown(!showDropDown);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(customerActions.fetchCustomer(id));
    }
    //eslint-disable-next-line
  }, [id]);
  const getSelectedCustomer = async () => {
    await axios.get("api/customer").then((response) => {
      let currentCustomer = response?.data?.toReturn?.filter((item) => item?.customer?._id === id);
      setSelectedCustomer(currentCustomer[0]);
    });
  };

  useEffect(() => {
    getSelectedCustomer();
    //eslint-disable-next-line
  }, []);

  const { user } = useSelector((state) => ({
    user: state.auth?.user,
  }));
  let currency = user?.companyId?.currency || "SAR";
  let customerData = {
    name: `${selectedCustomer?.customer?.name?.first} ${selectedCustomer?.customer?.name?.last} `,
    country: selectedCustomer?.customer?.country,
    mobile: selectedCustomer?.customer?.mobile,
    email: selectedCustomer?.customer?.email,
    totalInvoices: selectedCustomer?.totalInvoices,
    totalSales: `${Number(selectedCustomer?.totalSales).toFixed(2)} ${currency}` || `0.00 ${currency}`,
    firstInvoice: selectedCustomer?.firstInvoice?.created_at ? moment(selectedCustomer?.firstInvoice?.created_at).format("D MMM Y") : "",
    lastInvoice: selectedCustomer?.lastInvoice?.created_at ? moment(selectedCustomer?.lastInvoice?.created_at).format("D MMM Y") : "",
    loyaltyPointsBalance: `${
      selectedCustomer?.customer?.pointsBalance ? Number(selectedCustomer?.customer?.pointsBalance)?.toFixed(2) : "0.00"
    } ${currency}`,
  };

  let basicCustomerInfo = [
    {
      text: customerData?.email,
      icon: emailIcon,
    },
    {
      text: customerData?.mobile,
      icon: mobileIcon,
    },
    {
      text: customerData?.country,
      icon: locIcon,
    },
  ];
  let detailedCustomerInfo = [
    {
      title: i18n("DASHBOARD.Invoices"),
      icon: invoicesIcon,
      value: customerData?.totalInvoices,
    },
    {
      title: i18n("DASHBOARD.TotalSales"),
      icon: totalSalesIcon,
      value: customerData?.totalSales,
    },
    {
      title: i18n("Customer.FirstInvoice"),
      icon: firstInvoicIcon,
      value: customerData?.firstInvoice || "",
    },
    {
      title: i18n("Customer.LastInvoice"),
      icon: firstInvoicIcon,
      value: customerData?.lastInvoice || "",
    },
    {
      title: i18n("Customer.LoyaltyPoints"),
      icon: loyaltyIcon,
      value: customerData?.loyaltyPointsBalance || "0.00 SAR",
    },
  ];

  const CurrencyValue = ({ value, currency }) => {
    return (
      <span className="d-inline-flex align-items-center">
        <span>{value?.replace("SAR", "")}</span>

        {currency === "SAR" && (
          <img
            src={sarCurrencySymbol}
            alt="SAR"
            style={{
              width: "14px",
              height: "14px",
              objectFit: "contain",
              marginLeft: "3px",
            }}
          />
        )}
      </span>
    );
  };
  return (
    <div>
      <Modal isOpen={show} className="mx-auto my-auto modal" centered style={{ minWidth: "365px", minHeight: "572px" }}>
        <ModalBody style={{ background: "#FFFFFF", width: "100%", height: "100%", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
          <div className={`d-flex justify-content-between align-items-center pb-3 `} style={{ borderBottom: "2px solid #E0E0E0" }}>
            <div className="d-flex align-items-center gap-3">
              <span className="cursor-pointer" onClick={onHide}>
                <img src={backIcon} alt="back-icon" />
              </span>{" "}
              <span className="px-3" style={{ color: "#333333", fontSize: "16px", fontWeight: 700 }}>
                {i18n("Customer.CustomerProfile")}
              </span>
            </div>
            <div className="position-relative relative">
              <img src={actionsIcon} onClick={toggleDropDown} alt="actions-icon" className="cursor-pointer" />
              {showDropDown ? (
                <div
                  className="absolute position-absolute p-3 top-2 bg-white"
                  style={{
                    boxShadow: "-4px 4px 30px 0px #00000066",
                    minWidth: "148px",
                    right: selectedLanguage === "english" && "-0.4rem",
                    left: selectedLanguage === "arabic" && "-0.4rem",
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: 400,
                    textAlign: selectedLanguage === "arabic" ? "right" : "left",
                  }}
                >
                  <div className="cursor-pointer pb-4" onClick={() => openEditCustomerDialog(id)}>
                    {i18n("Customer.EditProfile")}
                  </div>
                  <div className="cursor-pointer" onClick={() => openEditCustomerPointsDialog(id)} style={{ whiteSpace: "nowrap" }}>
                    {i18n("Customer.EditPointsBalance")}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div
            className="pb-3 mt-4 flex-column d-flex justify-content-center align-items-center"
            style={{ borderBottom: "2px solid #E0E0E0", gap: "1rem" }}
          >
            <div
              className="d-flex  align-items-center justify-content-center"
              style={{ background: "#828282", padding: "1rem", borderRadius: "100%", width: "40px", height: "40px" }}
            >
              <img src={accountIcon} alt="account" />
            </div>
            <div style={{ color: "#333333", fontSize: 16, fontWeight: 700 }}>{customerData?.name}</div>
          </div>
          <div className="pb-5 my-5  d-flex flex-column align-items-start" style={{ gap: "2rem" }}>
            {basicCustomerInfo?.map((item) => {
              return (
                <div className="d-flex align-items-center">
                  <img src={item?.icon} alt="icon" />
                  <div className="px-4" style={{ color: "#333333", fontSize: 14, fontWeight: 400 }}>
                    {item?.text}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="pt-5 my-5  d-flex flex-column align-items-start" style={{ borderTop: "2px solid #E0E0E0", gap: "2rem" }}>
            {detailedCustomerInfo?.map((item, index) => {
              let condition = item?.title === i18n("Customer.LoyaltyPoints") || item?.title === i18n("DASHBOARD.TotalSales");
              return (
                <div key={index} className="d-flex align-items-center w-100 justify-content-between">
                  <div className="d-flex align-items-center ">
                    <img src={item?.icon} alt="icon" />
                    <div className="px-4" style={{ color: "#828282", fontSize: 14, fontWeight: 400 }}>
                      {item?.title}
                    </div>
                  </div>
                  {/* <div style={{ color: "#333333", fontSize: 14, fontWeight: 400 }}>{item?.value}</div> */}
                  <div style={{ color: "#333333", fontSize: 14, fontWeight: 400 }}>
                    {condition ? <CurrencyValue value={item.value} currency={currency} /> : item?.value}
                  </div>
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ViewCustomerProfile;
